import React, { useEffect } from "react";

import { useQuery } from "@tanstack/react-query";
import Constants from "../../../utils/Constants";
import axios from "axios";
import SplashScreen from "../../../components/loader/SplashScreen/SplashScreen";

import { Export, Restart } from "@carbon/icons-react";
import SearchHead from "../../../components/custom/SearchHead";
import { useState } from "react";
import ReactPaginate from "react-paginate";

const Subscribe = () => {
  const [page, setPage] = useState(1);
  const [loader, Setloader] = useState(false);
  const [searchparam , setsearchparam] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const CallSubData = (page) => {
    return axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        page: page || 1,
        limit: 100,
        ...(searchparam ? { search: searchparam } : {}),
        ...(startDate ? { 'createdAt[gte]': startDate } : {}),
        ...(endDate ? { 'createdAt[lte]': endDate } : {}),
      },
      url: Constants.url + "subscribers/list",
    }).then((res) => {
      return res.data.data;
    });
  };

  const {
    data: SubData,
    isLoading,
    refetch,
  } = useQuery({
    queryFn: () => CallSubData(page),
    queryKey: ["SubData", page],
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });


  useEffect(() => {
    refetch()
  } , [searchparam , startDate , endDate])

  const headers = [{ label: "Email", key: "email" }];

  const Refresh = () => {
    Setloader(true);
    refetch().then(() => {
      Setloader(false);
    });
  };

  return (
    <>
      {!isLoading && !loader ? (
        <div className="uk-grid" uk-grid="">
          <div className="uk-width-1-1">
            <SearchHead
              searchparam = {searchparam}
              RefreshFunc={Refresh}
              headers={headers}
              CsvData={SubData.subscribers}
              Filename={"Subscribe_data.csv"}
              setsearchparam ={setsearchparam}
              endpoint = 'subscribers'
              startDate = {startDate}
              endDate = {endDate}
              setStartdate = {setStartDate}
              setEndDate = {setEndDate}
            />

            <div className="analyticsTableWrp uk-overflow-auto ">
              <table className="uk-table uk-table-striped   ">
                <thead className="table-header-shadow">
                  <tr>
                    <th className="uk-table-shrink"> S.NO</th>
                    <th>Email</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {SubData?.subscribers.map((item, index) => (
                    <tr key={index}>
                      <td>{(page - 1) * 100 + (index + 1)}</td>
                      <td>{item.email || "-"}</td>
                      {/* <td>{item.createdAt || "-" }</td> */}
                      <td>
                        {" "}
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleString("en-US", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              // second: "2-digit", // optional, if you need seconds
                              hour12: true, // for 12-hour format
                              timeZone: "UTC",
                            })
                          : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationcard uk-card uk-card-default ">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(SubData.totalRecords / 100)}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(e) => setPage(e.selected + 1)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default Subscribe;
